import { defineStore } from 'pinia';
export const useModalsStore = defineStore('modals', {
    state() {
        return {
            relationModal: {
                visible: false,
                title: undefined,
                content: undefined,
                cancelName: undefined,
                confirmName: undefined,
                promiseResolve: null,
                buttonList: [],
            },
            actionData: {},
            showBundlePopup: false,
            bundlePopupConfirmVersion: 0,
        };
    },
    actions: {
        updateRelationModal(visible, title, content, cancelName = '取消', confirmName = '添加', buttonList) {
            this.relationModal.visible = visible;
            this.relationModal.title = title;
            this.relationModal.content = content;
            this.relationModal.cancelName = cancelName;
            this.relationModal.confirmName = confirmName;
            this.relationModal.buttonList = buttonList;
            return new Promise((resolve) => {
                this.relationModal.promiseResolve = resolve;
            }).then((bool) => ({
                close: () => {
                    this.relationModal.visible = false;
                },
                bool,
            }));
        },
        relationModalConfirm(data) {
            data ? (this.actionData = data) : {};
            this.relationModal.promiseResolve?.(true);
        },
        relationModalCancel(data) {
            data ? (this.actionData = data) : {};
            this.relationModal.visible = false;
            this.relationModal.promiseResolve?.(false);
        },
        toggleBundlePopup(visible) {
            this.showBundlePopup = visible ?? !this.showBundlePopup;
        },
        notifyBundlePopupConfirm() {
            this.bundlePopupConfirmVersion += 1;
        },
    },
});
